// extracted by mini-css-extract-plugin
module.exports =  {"header-rating":"aM1v0Ab","headerRating":"aM1v0Ab","header-rating-space-between":"O75sBut","headerRatingSpaceBetween":"O75sBut"};